'use client';

import { BookDemoButton } from '@/components/ui';
import IndustryHero from '@/components/industry/IndustryHero';
import IndustryCommandCentre from '@/components/industry/IndustryCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

const BLUE = { color: 'var(--brand)' };
const DEEP = { color: 'var(--brand-deep)' };

const CC = {
  pulseTitle: 'Student sentiment pulse',
  kpis: [
    { val: '960', lbl: 'Live mentions', live: true },
    { val: '72', lbl: 'Open escalations' },
    { val: '4.5m', lbl: 'Avg. first response' },
  ],
  sentiment: [
    { lbl: 'Positive', pct: 36, tone: 'positive' },
    { lbl: 'Neutral', pct: 34, tone: 'neutral' },
    { lbl: 'Negative', pct: 30, tone: 'negative' },
  ],
  sla: { pct: 74, lbl: 'SLA met' },
  tickerLabel: 'Incoming complaints',
  tickerItems: [
    { letter: 'A', text: 'Fee refund pending for 3 weeks', handle: '@aarav_p', tag: 'Refund', tagLevel: 'high' },
    { letter: 'M', text: 'Admission status still not updated', handle: '@meera_s', tag: 'Admission', tagLevel: 'med' },
    { letter: 'K', text: 'Hostel conditions are unacceptable', handle: '@karan_d', tag: 'Campus', tagLevel: 'med' },
    { letter: 'R', text: 'Will warn others about this college', handle: '@riya_t', tag: 'Reputation', tagLevel: 'high' },
  ],
  chips: [
    { variant: 'light', title: 'Enrolment risk', sub: 'Negative cluster in one cohort' },
    { variant: 'dark', title: 'AgentIQ routed', sub: 'Refund case → bursar in 2s' },
  ],
};

export default function EducationHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('breadcrumb.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('Education'),
      }}
      title={
        <>
          {t('industries_education.every_student_review_is_a_trust_sig')}{' '}
          <span className="serif-accent italic">{t('industries_education.education_brand_reputation_manageme')}</span>
          {' '}{t('industries_education.for')}{' '}
          <span className="serif-accent italic">{t('industries_education.edtech_universities_coaching_instit')}</span>.
        </>
      }
      lead={
        <>
          {t('industries_education.edtech_has_learned_its_hardest_less')}{' '}
          <span style={BLUE}>{t('industries_education.student_trust')}</span> {t('industries_education.collapsed_overnight_brands_that_had')}{' '}
          <span style={DEEP}>{t('industries_education.locobuzz_keeps_you_ahead_of_that_co')}</span>
        </>
      }
      actions={
        <BookDemoButton label="Book a Personalised Education Brand Intelligence Demo" />
      }
      visual={<IndustryCommandCentre ariaLabel="Education student experience command centre" {...CC} />}
    />
  );
}
